import { Template } from '../../../../constants/Types';
import { DEFAULT_TEMPLATE_TITLE } from '../../../../constants/Utils';

const PresetTemplates: Template[] = [
  {
    id: '4',
    name: 'Coffee machine',
    title: DEFAULT_TEMPLATE_TITLE,
    subtitle: 'What issues do you want to report?',
    issues: [
      {
        Enabled: true,
        Text: 'No Beans',
        Priority: 3,
        UserGroupId: [],
        Id: '0',
      },
      {
        Enabled: true,
        Text: 'Filter Needs Replacing',
        Priority: 3,
        UserGroupId: [],
        Id: '1',
      },
      {
        Enabled: true,
        Text: 'No Milk',
        Priority: 3,
        UserGroupId: [],
        Id: '2',
      },
      {
        Enabled: true,
        Text: ' Not Working',
        Priority: 3,
        UserGroupId: [],
        Id: '3',
      },
      {
        Enabled: true,
        Text: 'Other',
        Priority: 3,
        UserGroupId: [],
        Id: '4',
      },
      {
        Enabled: true,
        Text: 'Need Cleaning',
        Priority: 3,
        UserGroupId: [],
        Id: '5',
      },
    ],
    customfields: [],
  },
  {
    id: '1',
    name: 'Desks',
    title: DEFAULT_TEMPLATE_TITLE,
    subtitle: 'What issues do you want to report?',
    issues: [
      {
        Priority: 2,
        Text: 'Keyboard not working',
        Id: '6',
      },
      {
        Priority: 2,
        Text: 'Mouse not working ',
        Id: '7',
      },
      {
        Priority: 2,
        Text: 'Connection assistance needed',
        Id: '8',
      },
      {
        Priority: 2,
        Text: 'Cables missing',
        Id: '9',
      },
      {
        Text: 'Other',
        Priority: 4,
        Id: '10',
      },
    ],
    customfields: [],
  },

  {
    id: '2',
    name: 'Meeting Room',
    title: DEFAULT_TEMPLATE_TITLE,
    subtitle: 'What issues do you want to report?',
    issues: [
      {
        Priority: 1,
        Text: 'Need assistance to connect',
        Id: '11',
      },
      {
        Priority: 3,
        Text: 'Needs cleaning',
        Id: '12',
      },
      {
        Priority: 3,
        Text: 'Display Not Working',
        Id: '13',
      },
      {
        Priority: 3,
        Text: 'Touchpanel Not Responding',
        Id: '14',
      },
      {
        Priority: 3,
        Text: 'Test',
        Id: '15',
      },
      {
        Priority: 3,
        Text: 'Other',
        Id: '16',
      },
    ],
    customfields: [],
  },

  {
    id: '3',
    name: 'Printer',
    title: DEFAULT_TEMPLATE_TITLE,
    subtitle: 'What issues do you want to report?',
    issues: [
      {
        Priority: 4,
        Text: 'No Paper',
        Id: '17',
      },
      {
        Priority: 4,
        Text: 'Paper Jam',
        Id: '18',
      },
      {
        Priority: 4,
        Text: 'Cannot Log In',
        Id: '19',
      },
      {
        Priority: 4,
        Text: 'Machine is broken',
        Id: '20',
      },
      {
        Text: 'Other',
        Priority: 3,
        Id: '21',
      },
    ],
    customfields: [],
  },
  {
    id: '0',
    name: 'Toilet',
    title: DEFAULT_TEMPLATE_TITLE,
    subtitle: 'What issues do you want to report?',
    issues: [
      {
        Enabled: true,
        Text: 'No Toilet Roll',
        Priority: 3,
        UserGroupId: [],
        Id: '22',
      },
      {
        Enabled: true,
        Text: 'No Soap',
        Priority: 3,
        UserGroupId: [],
        Id: '23',
      },
      {
        Enabled: true,
        Text: 'Needs Cleaning',
        Priority: 3,
        UserGroupId: [],
        Id: '24',
      },
      {
        Enabled: true,
        Text: 'Not Flushing',
        Priority: 1,
        UserGroupId: [],
        Id: '25',
      },
      {
        Enabled: false,
        Text: 'Other',
        Priority: 3,
        UserGroupId: [],
        Id: '26',
      },
    ],
    customfields: [],
  },
];

export default PresetTemplates;
